import React from "react";
import { motion } from "framer-motion";

export function StatCard({ label, value, unit, icon: Icon, accent = false, testid }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden rounded-xl border border-mt-border bg-mt-card p-4 shadow-sm"
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-mt-mutedfg">{label}</span>
        {Icon && (
          <span className={`grid h-8 w-8 place-items-center rounded-md ${accent ? "bg-mt-primary text-white" : "bg-mt-secondary text-mt-text"}`}>
            <Icon size={16} />
          </span>
        )}
      </div>
      <div className="mt-3 flex items-baseline gap-1">
        <span className="font-mono text-3xl font-bold leading-none text-mt-text">{value}</span>
        {unit && <span className="text-sm font-semibold text-mt-mutedfg">{unit}</span>}
      </div>
    </motion.div>
  );
}
